function Hero() {
	return (
		<section
			id="home"
			className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-900 via-slate-800 to-cyan-900 px-6 py-14 text-white shadow-2xl sm:px-10 sm:py-16 lg:px-14 lg:py-20"
		>
			<div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-cyan-300/20 blur-2xl" />
			<div className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-cyan-400/20 blur-3xl" />

			<div className="relative mx-auto max-w-4xl text-center">
					<p className="inline-flex rounded-full border border-cyan-200/40 bg-white/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-cyan-100">
					VIANCE HEALTHCARE SYSTEMS PRIVATE LIMITED
					</p>

					<h1 className="mt-4 text-4xl font-extrabold leading-tight sm:text-5xl md:text-6xl">
					Engineering Digital Products for Healthcare Operations
					</h1>

					<p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-200 sm:text-lg md:text-xl">
					We build context-aware mobile apps, websites, and database systems that improve healthcare workflows,
					data visibility, and service delivery.
					</p>

					<div className="mt-7 flex w-full flex-col items-stretch justify-center gap-3 sm:w-auto sm:flex-row sm:items-center sm:justify-center">
						<a
							href="#contact"
							className="inline-flex items-center justify-center rounded-xl bg-cyan-400 px-7 py-3.5 text-sm font-semibold text-slate-900 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-cyan-300"
						>
							Start Project
						</a>
						<a
							href="#services"
							className="inline-flex items-center justify-center rounded-xl border border-cyan-100/60 px-7 py-3.5 text-sm font-semibold text-cyan-100 transition-all duration-300 hover:-translate-y-0.5 hover:bg-cyan-200/10"
						>
							Explore Services
						</a>
					</div>
			</div>
		</section>
	);
}

export default Hero;
